const Web3Provider = require('./Web3Provider');
const ErrorTemplate = require('./ErrorTemplate');

module.exports.Web3Provider = Web3Provider;
module.exports.ErrorTemplate = ErrorTemplate;

module.exports = {
  Web3Provider,
  ErrorTemplate
};



// WEBPACK FOOTER //
// ./src/index.js